<template>
  <BaseEditModal
    :displayName="templateMaster.display_name"
    helpFileName="EditTemplateModal"
    :itemtype="itemtype"
    :tabs="tabs"
    :icon="'mdi-cube-scan'"
    :masterObj="templateMaster"
    :saveFunc="saveTemplate"
    :deleteFunc="deleteTemplate"
    :instanceDeletable="!templateMaster.default_template"
    @close="emit('close')"
    @locked="(bool) => emit('locked', bool)">
    <template v-slot:prepend-buttons>
      <v-btn
        variant="flat"
        style="background-color: var(--inner-background)"
        class="mr-2"
        :href="
          state.devRedirect +
          '/api/download_template?uid=' +
          templateMaster.uid +
          '&token=' +
          auth()
        ">
        <v-icon style="font-size: 22px">mdi-tray-arrow-down</v-icon>
      </v-btn>
      <v-btn
        v-if="templateMaster.extra_info?.preset"
        :loading="duplicateLoading"
        variant="flat"
        @click="duplicatePreset()"
        style="background-color: var(--inner-background)"
        class="mr-2">
        <v-icon style="font-size: 22px">mdi-content-duplicate</v-icon>
      </v-btn>
    </template>
  </BaseEditModal>
</template>
<script setup>
import { ref } from 'vue';
import { deluge, state } from '../../stores/deluge';
import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import { $http } from '../../stores/http';

import { unMergeSceneData } from '../../utils/nestedUnmerge';

// Template Utils
import { deleteTemplate, getCopyOfTemplate } from './utils/templateUtils';

// patch stuff
import { createPatch } from '../../utils/JSONpatch';

// Template Sub Components
import TemplateDetails from './TemplateModalComponents/TemplateDetails.vue';
import TemplateRelatedFiles from './TemplateModalComponents/TemplateRelatedFiles.vue';
import TemplateVariables from './TemplateModalComponents/TemplateVariables.vue';
import TemplatePlayConditions from './TemplateModalComponents/TemplatePlayConditions.vue';
import TemplateTriggers from './TemplateModalComponents/TemplateTriggers.vue';
import TemplateEngineBehaviour from './TemplateModalComponents/TemplateEngineBehaviour.vue';
import TemplateUpgrade from './TemplateModalComponents/TemplateUpgrade.vue';
import TemplateTags from './TemplateModalComponents/TemplateTags.vue';
import TemplateLoadTimes from './TemplateModalComponents/TemplateLoadTimes.vue';

// template_index is actually a UID
const props = defineProps(['template', 'itemtype']);
const emit = defineEmits(['close', 'locked', 'deleted']);

const templateMaster = getCopyOfTemplate(props.template);
const duplicateLoading = ref(false);
// Tabs - must be 0 indexed.
const tabs = [
  {
    id: 0,
    title: 'Variables',
    icon: 'mdi-tune',
    display: true,
    component: TemplateVariables,
  },
  {
    id: 1,
    title: 'Details',
    icon: 'mdi-rename-box',
    display: true,
    component: TemplateDetails,
  },
  {
    id: 2,
    title: 'Related Files',
    icon: 'mdi-image-search',
    display: true,
    component: TemplateRelatedFiles,
  },
  {
    id: 3,
    title: 'Play Conditions',
    icon: 'mdi-motion-play-outline',
    display: true,
    component: TemplatePlayConditions,
    props: {
      itemtype: props.itemtype,
    },
  },
  // {
  //   id: 4,
  //   title: 'Triggers',
  //   icon: 'mdi-share-all',
  //   display: true,
  //   component: TemplateTriggers,
  // },
  {
    id: 4,
    title: 'Engine Behaviour',
    icon: 'mdi-engine',
    display:
      templateMaster?.name.toLowerCase() !== 'ndi' &&
      !templateMaster?.extra_info?.preset,
    component: TemplateEngineBehaviour,
  },
  {
    id: 5,
    title: 'Load Timings',
    icon: 'mdi-book-clock',
    display: !templateMaster?.extra_info?.preset,
    component: TemplateLoadTimes,
  },
  {
    id: 6,
    title: 'Upgrade',
    icon: 'mdi-file-replace',
    display:
      templateMaster?.default_template !== true &&
      !templateMaster?.extra_info?.preset,
    component: TemplateUpgrade,
  },
  {
    id: 7,
    title: 'Tags',
    icon: 'mdi-tag',
    display: true,
    component: TemplateTags,
  },
];

function auth() {
  return localStorage.getItem('authentication_token');
}

async function saveTemplate(templateUID, newTemplateData) {
  if ('editableComposedSD' in newTemplateData) {
    const editedMergedObj = newTemplateData.editableComposedSD;
    delete newTemplateData['editableComposedSD'];

    const template = deluge.templates[templateUID];
    const currentState = template.scene_data;

    const newState = unMergeSceneData({
      context: 'template',
      editedMergedObj: editedMergedObj,
      templates: deluge.templates,
      template: templateMaster,
    });

    const patch = createPatch(currentState, newState);
    newTemplateData.patch_svars = patch;
  }
  return await $http(
    'PUT',
    '/dynamic_engine/update_template_data?template_uid=' + templateUID,
    JSON.stringify(newTemplateData)
  );
}
async function duplicatePreset() {
  duplicateLoading.value = true;
  let name = window.prompt(
    'Name of the new template',
    props.template.display_name
  );

  if (!name) {
    duplicateLoading.value = false;
    return;
  }
  try {
    await $http(
      'POST',
      '/duplicate_preset?preset_uid=' + props.template.uid + '&name=' + name
    );
    duplicateLoading.value = false;
    emit('close');
  } catch (e) {
    console.log('error');
  }
  duplicateLoading.value = false;
}
// END Tabs
</script>

<style scoped></style>
